import React from 'react';
import { ChildrenPropType } from '../../services/proptypes';
import './WithBackgroundImage.css';
var defaultProps = {
  children: null,
  className: ''
};
var WithBackgroundImage = function WithBackgroundImage(props) {
  var image = props.image,
    children = props.children,
    className = props.className;
  return /*#__PURE__*/React.createElement("div", {
    className: "with-background-image-hoc ".concat(className),
    style: {
      backgroundImage: "url(".concat(image, ")")
    }
  }, children);
};
WithBackgroundImage.defaultProps = defaultProps;
export default WithBackgroundImage;